import React from 'react';
import numeral from 'numeral';

import commonService from '../../../services/commonService';
import { formatCurrency } from '../../../utils';
import { WIDGET_NAMES } from '../../../utils/constant';

import StatesCountyMap from './index';
import titleSalaryOnlyStateMapTemplate from './titleSalaryOnlyStateMapTemplate';

import classes from './index.module.css';

const TitleSalaryOnlyStatesMap = (props) => {
  const { title, nationalAverageAnnualSalary, mapTooltipLine2 } = props;
  const svgFileUrl = commonService.getTitleSalaryOnlyStatesMapFileUrl(title);

  const gtmEventNames = {
    open: 'Salary Heatmap Modal Open',
  };
  const mapTooltip = {
    title: 'Average Salary',
    valueFormatFunc: formatCurrency,
    subTextFormatFunc: (id, salary) => {
      const percentage =
        (100 * salary) / parseInt((nationalAverageAnnualSalary + '').replace(/\D/g, ''));
      const lessGreat = percentage < 100 ? 'less' : 'more';
      return `${parseInt(
        Math.abs(100 - percentage)
      )}% ${lessGreat} than the average salary in the United States`;
    },
  };
  const legendTooltip = {
    title: 'Salary Range',
    valueFormatFunc: (range, isLast) => {
      const rangeArr = range.split('-') || [];
      if (!rangeArr || !rangeArr.length) {
        return '';
      }
      return `${numeral(rangeArr[0]).format('$0a')} - ${numeral(rangeArr[1]).format('$0a')}${
        isLast ? '+' : ''
      }`;
    },
  };
  const legendLabelsCallback = (legendItems) => {
    if (!legendItems || !legendItems.length || !legendItems[0].rangeDisplay) {
      return <></>;
    }

    const salaryMinFormatted = legendItems[0].rangeDisplay.split('-')[0];
    const salaryMaxFormatted = legendItems[legendItems.length - 1].rangeDisplay.split('-')[1];

    return (
      <>
        <span className={classes['legend-label-part']}>
          <span className={classes['county-value']}>{salaryMinFormatted}</span>
          <span>Lowest</span>
        </span>
        <span className={classes['legend-label-part']}>
          <span>Highest</span>
          <span className={classes['county-value']}>{salaryMaxFormatted}</span>
        </span>
      </>
    );
  };

  return (
    <StatesCountyMap
      {...props}
      svgFileUrl={svgFileUrl}
      gtmEventNames={gtmEventNames}
      embedWidgetType={WIDGET_NAMES.TITLE_SALARY_STATES_MAP}
      mapTooltip={mapTooltip}
      mapTooltipLine2={mapTooltipLine2}
      legendTooltip={legendTooltip}
      legendLabelsCallback={legendLabelsCallback}
      MapTemplate={titleSalaryOnlyStateMapTemplate}
    />
  );
};

export default TitleSalaryOnlyStatesMap;
